import React, { useState } from "react";
import { Box } from "@mui/material";

import AdminSidebar from "../sidebar/AdminSidebar";
import AdminHeader from "../header/AdminHeader";
import ProfileMenu from "../profile/ProfileMenu";
import { AdminLayoutProps } from "../types/admin";

const drawerWidth = 280;

const AdminLayout: React.FC<AdminLayoutProps> = ({
  children,
  open,
  onDrawerToggle,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleProfileMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box sx={{ display: "flex", background: "#ffffff", minHeight: "100vh" }}>
      <AdminSidebar open={open} onProfileMenuOpen={handleProfileMenuOpen} />
      <AdminHeader open={open} onDrawerToggle={onDrawerToggle} />

      {/* Main Content Area */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          background: "#ffffff",
          width: open ? `calc(100% - ${drawerWidth}px)` : "100%",
          marginLeft: open ? `${drawerWidth}px` : 0,
          transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
          position: "absolute",
          top: 0,
          right: 0,
          minHeight: "100vh",
        }}
      >
        {/* Page Content */}
        <Box
          sx={{
            p: 4,
            pt: 14, // Add top padding to account for fixed header
            minHeight: "100vh",
            background: "#fafafa",
            width: "100%",
            overflow: "auto",
          }}
        >
          {children}
        </Box>
      </Box>

      <ProfileMenu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleProfileMenuClose}
      />
    </Box>
  );
};

export default AdminLayout;
